import {Injectable} from "@angular/core";
import {HttpClient} from "@angular/common/http";
import {BusinessTypeCategoriesService} from "../../../../../common/api/dictionaries/business-type-categories.service";

@Injectable()
export class BackofficeBusinessTypeCategoriesService extends BusinessTypeCategoriesService {
    static readonly context = 'backoffice'

    constructor(http: HttpClient) {
        super(http, BackofficeBusinessTypeCategoriesService.context);
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/dashboard/app/shared/api/service/backoffice-business-type-categories.service.ts